import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from 'config/translations/i18n';
import { I18nextProvider } from 'react-i18next';
import { IUser } from './types/user-type';
import { switchTheme } from 'config/app-constants';
import './utilities/icons/my-fa-icons';

switchTheme(false);

fetch('/auth/GetLoggedUser').then(async response => {
  if (response.ok === true) {
    const userData = await response.json();
    init(userData);
  } else if (response.status === 401) {
    var url = encodeURIComponent(window.location.href);
    window.location.href = `/auth?returnUrl=${url}`;
  }
}, error => {
  console.error('Failed to fetch user data', error);
});

function init(userData: IUser) {
  document.body.classList.remove('loading');
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback="loading">
          <App user={userData} />
        </Suspense>
      </I18nextProvider>
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
